import styled from 'styled-components'

import theme from 'theme_'
import { Font14, H5 } from 'components/Typography'

export const NetworkWizardHeaderJobNameWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: ${theme.colors.lighterGrey};
  padding: ${theme.spacing.tiny} ${theme.spacing.xs};
  ${Font14};
  font-weight: 900;
`

export const NetworkWizardHeaderTitle = styled(H5)`
  flex-shrink: 0;
`

export const NetworkWizardHeaderJobName = styled.span`
  word-break: break-word;
`
